import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../lib/api'
import { kvSet } from '../lib/db'
import { useApp } from '../lib/store'
import { AppBar } from '../components/AppBar'
import { BANKS } from '../lib/vietqr'

export function BankSettingsScreen() {
  const nav = useNavigate()
  const shop = useApp((s) => s.shop)
  const say = useApp((s) => s.say)

  const [bin, setBin] = useState(shop?.bankBin ?? '')
  const [accountNo, setAccountNo] = useState(shop?.bankAccountNo ?? '')
  const [accountName, setAccountName] = useState(shop?.bankAccountName ?? '')
  const [busy, setBusy] = useState(false)

  async function save() {
    if (!bin || !accountNo.trim()) {
      say('Chọn ngân hàng và nhập số tài khoản')
      return
    }
    setBusy(true)
    try {
      await api.post('/api/catalog/bank', {
        bankBin: bin,
        bankAccountNo: accountNo.trim(),
        bankAccountName: accountName.trim(),
      })
      const next = {
        ...shop!,
        bankBin: bin,
        bankAccountNo: accountNo.trim(),
        bankAccountName: accountName.trim() || null,
      }
      await kvSet('shop', next)
      useApp.setState({ shop: next })
      say('Đã lưu tài khoản nhận tiền')
      nav('/settings')
    } catch (e) {
      say(e instanceof Error ? e.message : 'Chưa lưu được')
    }
    setBusy(false)
  }

  return (
    <div className="screen">
      <AppBar title="Tài khoản nhận tiền" onBack={() => nav('/settings')} />

      <div className="body">
        <p className="hint">
          Khai một lần. Sau đó mỗi lần khách chuyển khoản, app dựng sẵn mã QR đúng số tiền và đúng
          số hoá đơn — khách quét là xong, không phải gõ tay.
        </p>

        <label className="field">
          <span>Ngân hàng</span>
          <select value={bin} onChange={(e) => setBin(e.target.value)}>
            <option value="">— Chọn ngân hàng —</option>
            {BANKS.map((b) => (
              <option key={b.bin} value={b.bin}>
                {b.short}
              </option>
            ))}
          </select>
        </label>

        <label className="field">
          <span>Số tài khoản</span>
          <input
            inputMode="numeric"
            value={accountNo}
            onChange={(e) => setAccountNo(e.target.value)}
            placeholder="0071000123456"
          />
        </label>

        <label className="field">
          <span>Tên chủ tài khoản</span>
          <input
            value={accountName}
            onChange={(e) => setAccountName(e.target.value)}
            placeholder="NGUYEN THI HA"
            maxLength={120}
          />
        </label>
      </div>

      <div className="dock">
        <button type="button" className="btn btn-brand btn-lg grow" onClick={save} disabled={busy}>
          {busy ? 'Đang lưu…' : 'Lưu'}
        </button>
      </div>
    </div>
  )
}
